import { StatoNotaEnum } from "../enum/stato-nota-enum";

import { TipoNotaLiquidazioneEnum } from "../enum/tipo-nota-liquidazione-enum";

import { AnagraficaBeneficiarioDTO } from "./anagrafica-beneficiarioDTO";
import { DatiPagamentoDTO } from "./dati-pagamentoDTO";
import { DecretoDTO } from "./decretoDTO";
import { DocumentoDTO } from "./documentoDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";
import { SettoreDTO } from "./settoreDTO";
import { UtenteDTO } from "./utenteDTO";
import { NotaDaSostituireDTO } from "./nota-da-sostituireDTO";

export class NotaLiquidazioneDTO {
  id: string;
  oggetto: string;
  estensore: UtenteDTO;
  settore: SettoreDTO;
  decreto: DecretoDTO;
  numeroFattura: string;
  riservata: boolean;
  tipologiaNota: TipoNotaLiquidazioneEnum;
  anagraficheBeneficiarie: AnagraficaBeneficiarioDTO[];
  responsabile: UtenteDTO;
  statoNota: StatoNotaEnum;
  primario: DocumentoDTO;
  contenutoNota: string;
  dataUltimaModifica: string;
  dataInserimento: string;
  dataConclusione: string;
  motivoStato: string;
  metadatiRepertorio: MetadatiRepertorioDTO;
  datiPagamento: DatiPagamentoDTO[];
  notaDaSostituire: NotaDaSostituireDTO;
  settoreFirmatario: SettoreDTO;
  allegati: DocumentoDTO[];
  presaInCaricoUtente: UtenteDTO;
  cloneRitirata: boolean;
}
